<template>
  <div class="S-box">
    <!--系统设置主页面-->
    <div class="settings-box" v-if="!showSecurity">
      <div class="user-top">
        <div class="user-left">
          <img v-if="userInfo.avatar && userInfo.avatar.url != undefined" :src="userInfo.avatar.url" class="head" />
          <img class="head" v-else src="@/assets/images/user.png" alt="默认头像" />
          <div class="name">{{ userInfo.doctor ? userInfo.doctor.doctorName : '' }}</div>
        </div>
        <i class="el-icon-arrow-right" />
      </div>
      <div class="settings-ul">
        <div class="settings-li" @click="showSecurity = true">
          <span>账户与安全</span>
          <i class="el-icon-arrow-right" />
        </div>
        <div class="settings-li" @click="dialogVisible2 = true">
          <span>用户协议</span>
          <i class="el-icon-arrow-right" />
        </div>
        <div class="settings-li" @click="dialogVisible = true">
          <span>隐私政策</span>
          <i class="el-icon-arrow-right" />
        </div>
      </div>
      <el-button class="bt" style="margin: auto;margin-top: 280px;">退出登录</el-button>
    </div>
    <!--账号与安全-->
    <div class="AccountSecurity-box" v-if="showSecurity">
      <div class="title-box">账户与安全</div>

      <!--账号-->
      <div class="account-box" v-if="step === 1">
        <div class="account-li" @click="step = 2">
          <div class="account-left">手机号</div>
          <div class="account-right">{{ maskedPhone }}<i class="el-icon-arrow-right" /></div>
        </div>
        <div class="account-li" @click="handleChangePassword">
          <div class="account-left">设置密码</div>
          <div class="account-right" :class="{ active: !changePassword }">
            {{ changePassword ? '已设置' : '未设置' }}
            <i class="el-icon-arrow-right" />
          </div>
        </div>
        <div class="account-li" @click="cancelUser">
          <div class="account-left">
            注销账户
            <div style="color: #BD181E;margin-top: 6px;">注销后无法恢复，请谨慎操作</div>
          </div>
          <div class="account-right"><i class="el-icon-arrow-right" /></div>
        </div>
      </div>

      <!-- 验证中间四位 -->
      <div class="iphone-box" v-if="step === 2 || step === 6">
        <div class="iphone-label">为了保证您的账户安全，需先验证您的身份，验证成功后可以进行下一步操作。</div>
        <div class="iphone-number">{{ maskedPhone }}</div>
        <div class="iphone-p">请输入“*”号位缺失的4位手机号</div>
        <div class="iphone-yz">
          <input v-for="(n, i) in phoneDigits" :key="i" v-model="phoneDigits[i]" maxlength="1" ref="phoneInputs"
            @input="handleInputFocus(i, 'phone')" />
        </div>
        <div class="bt-box">
          <el-button class="bt" @click="step = 1">返回</el-button>
          <el-button class="bt" @click="handleNextStep">下一步</el-button>
        </div>
      </div>

      <!-- 验证码输入 -->
      <div class="iphone-box" v-if="step === 3 || step === 7">
        <div class="iphone-label">为了保证您的账户安全，需先验证您的身份，验证成功后可以进行下一步操作。</div>
        <div class="iphone-p" v-if="step === 3" :class="{ disabled: !canSend }" @click="handleSendCode">
          验证码已发送至手机 <span>{{ sendText }}</span>
        </div>
        <div class="iphone-p" v-if="step === 7" :class="{ disabled: !canSend }" @click="handleSendCodeThree">
          验证码已发送至手机 <span>{{ sendTextThree }}</span>
        </div>
        <div class="iphone-yzm">
          <input v-for="(n, i) in verifyCode" :key="i" v-model="verifyCode[i]" maxlength="1" ref="codeInputs"
            @input="handleInputFocus(i, 'code')" />
        </div>
        <div class="bt-box">
          <el-button class="bt" @click="step = 1">返回</el-button>
          <el-button class="bt" v-if="step === 3" @click="handleVerifyCode">下一步</el-button>
          <el-button class="bt" v-if="step === 7" @click="handleVerifyCode">确认注销账号</el-button>
        </div>
      </div>

      <!--最后一步更改新手机号-->
      <div class="update-box" v-if="step === 4">
        <div class="update-title">新手机号</div>
        <div class="update-input">
          <div class="ib">+86</div>
          <el-input v-model="newPhone" maxlength="11" placeholder="请输入新手机号" />
        </div>
        <div class="update-input">
          <el-input v-model="newVerifyCode" placeholder="短信验证码" />
          <el-button @click="handleSendCodeTwo">{{ sendTextTwo }}</el-button>
        </div>
        <div class="bt-box">
          <el-button class="bt" @click="step = 1">返回</el-button>
          <el-button class="bt" @click="bindingNewPhone">提交</el-button>
        </div>
      </div>

      <!-- 注销账户1 -->
      <div class="close-an-account-box" v-if="step === 5">
        <img class="close-an-account-img" src="@/assets/images/safety.png" alt="">
        <div class="close-an-account-title">注销账户不可恢复</div>
        <div class="close-an-account-subheading">在您正式开始注销账号之前，请阅读以下重要提示</div>
        <div class="close-an-account-list">
          <div class="close-an-account-item">该账号的全部个人资料、健康档案等信息特无法找回</div>
          <div class="close-an-account-item">该账号下的收藏、训练、鼾症监测报告等记录都将被清空， 且无法恢复</div>
          <div class="close-an-account-item">该账号所产生的评论，点赞等数据将被清空，且无法恢复</div>
          <div class="close-an-account-item">任何该账号下所累计的用户等级，用户积分，权益等都將作废且无法恢复</div>
        </div>
        <div class="close-an-account-known">
          <el-checkbox v-model="checked"></el-checkbox>
          我已经阅读<span class="close-an-account-span" @click="dialogVisible4 = true">《重要提醒》</span>，并知晓上述内容
        </div>
        <div class="close-an-account-btn">
          <el-button class="btn-item" @click="step = 1">返回</el-button>
          <el-button class="btn-item" @click="handleCancelAnAccount">下一步</el-button>
        </div>
      </div>

      <!-- 注销账户2 -->
      <div class="close-an-account-box" v-if="step === 8">
        <img class="close-an-account-img-two" src="@/assets/images/finished.png" alt="">
        <div class="close-an-account-title">注销成功，感谢您的支持</div>
        <div class="close-an-account-subheading">注销后，您需要了解以下信息</div>
        <div class="close-an-account-list">
          <div class="close-an-account-item">您的当前账号会被登出</div>
          <div class="close-an-account-item">您依然可以使用该手机号/微信号再次注册，但是注册成功更后将是与被注销账号不同的两个账号</div>
        </div>
        <div class="close-an-account-btn">
          <el-button class="btn-item" @click="onLogOut">我知道了</el-button>
        </div>
      </div>
    </div>
    <PrivacyDialog :visible.sync="dialogVisible" />
    <AgreementDialog :visible.sync="dialogVisible2" />
    <significanceDialog :visible.sync="dialogVisible4" :reminderHtml="reminderHtml"></significanceDialog>

    <!--修改密码-->
    <el-dialog title="设置密码" :visible.sync="dialogVisible3" width="400px" @close="handleClose">
      <el-form :model="formData" :rules="rules" ref="ruleForm">
        <el-form-item prop="phone">
          <el-input v-model="formData.phone" type="text" placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <!-- <el-form-item>
          <el-input v-model="formData.codeImg" type="text" placeholder="请输入图片验证码">
            <template slot="suffix">
              <img :src="codeImg" alt="" style="height: 90%; margin-top: 2px;cursor: pointer;" @click="getImgCode">
            </template>
</el-input>
</el-form-item> -->
        <el-form-item prop="code">
          <el-input v-model="formData.code" type="text" placeholder="请输入验证码">
            <template slot="append">
              <el-button plan @click="startCountdown">{{ countdownText }}</el-button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="passwordOld">
          <el-input v-model="formData.passwordOld" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item prop="passwordNew">
          <el-input v-model="formData.passwordNew" type="password" placeholder="确认密码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button plain @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="SubmitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getChangePhoneCode, verifyPhoneCode, changeNewPhone, getCurrentUser, changePasswordApi, getDestroyPhoneCode, getStaticResource, setPhoneDestroy } from '@/api/user'
import { getCode, sendLoginCode } from '@/api/login'
import PrivacyDialog from '@/components/modal/index.vue'
import AgreementDialog from '@/components/modal/index2.vue'
import significanceDialog from '@/components/modal/index3.vue'
import axios from 'axios';

export default {
  name: "index",
  components: { PrivacyDialog, AgreementDialog, significanceDialog },
  data() {
    return {
      dialogVisible: false,
      dialogVisible2: false,
      userInfo: {},
      showSecurity: false, // 显示账户与安全页
      step: 1,             // 当前步骤
      phoneDigits: ['', '', '', ''], // 中间四位
      validDigits: '',     // 正确中间四位
      verifyCode: ['', '', '', ''], // 验证码输入
      sendText: '发送',
      countdown: 60,
      timer: null,
      canSend: true,
      phone: '',
      newPhone: '',
      newVerifyCode: '',
      sendTextTwo: '获取验证码',
      canSendTwo: true,
      timerTwo: null,
      countdownTwo: 60,
      sendTextThree: '获取验证码',
      canSendThree: true,
      timerThree: null,
      countdownThree: 60,
      dialogVisible3: false,
      formData: {
        phone: '',
        codeImg: '',
        code: '',
        passwordNew: '',
        passwordOld: ''
      },
      codeImg: '',
      codeImgId: '',
      countdown2: 60, // 倒计时总时间（秒）
      isCounting: false, // 是否正在倒计时
      countdownText: '获取验证码',
      changePassword: false,
      rules: {
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        passwordNew: [{ required: true, message: '请输入确认密码', trigger: 'blur' }],
        passwordOld: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
      dialogVisible4: false,
      checked: false,
      reminder: '',
      reminderHtml: '',
    }
  },
  computed: {
    maskedPhone() {
      const phone = this.userInfo.phone || ''
      const match = phone.match(/^(\d{3})\d{4}(\d{4})$/)
      this.validDigits = match ? phone.slice(3, 7) : ''
      return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
    }
  },
  mounted() {
    const info = localStorage.getItem("userInfo")
    this.userInfo = info ? JSON.parse(info) : {}
    this.formData.phone = this.userInfo.phone
    this.changePassword = this.userInfo.changePassword
    // this.getImgCode()
    this.getStaticResource()
  },
  methods: {
    // 应用静态资源
    getStaticResource() {
      getStaticResource().then(res => {
        if (res.code == 'A00000') {
          this.reminder = res.data.filter(item => item.id == 'reminder.html')[0]
          axios.get(this.reminder.url)
          .then(response => {
            this.reminderHtml = response.data;
          })
          .catch(error => {
            console.error('获取HTML内容时出错:', error);
          });
        }
      })
    },
    // 绑定新的手机号
    bindingNewPhone() {
      const phonePattern = /^1[3-9]\d{9}$/;
      if (this.newPhone == "") {
        this.$message.warning('请输入新的手机号')
        return
      };
      if (!phonePattern.test(this.newPhone)) {
        this.$message.warning('请输入有效的手机号码')
        return
      };
      if (this.newVerifyCode == "") {
        this.$message.warning('请输入短信验证码')
        return
      };
      this.changeNewPhone()
    },
    // 账号手机号验证六位输入
    handleVerifyCode() {
      const code = this.verifyCode.join('')
      if (code.length !== 4) {
        this.$message.warning('请输入完整的4位验证码')
        return
      }
      if(this.step == 3) {
        this.verifyPhoneCode()
      }else if(this.step == 7) {
        this.setPhoneDestroy()
      }
    },
    // 手机号中间四位修改
    handleInputFocus(index, type) {
      const list = type === 'phone' ? this.phoneDigits : this.verifyCode
      const refs = type === 'phone' ? this.$refs.phoneInputs : this.$refs.codeInputs

      // 自动跳转到下一个输入框
      if (list[index] && index < list.length - 1) {
        this.$nextTick(() => {
          if (refs[index + 1]) {
            refs[index + 1].focus()
          }
        })
      }

      // 自动跳转上一个（删除时）
      if (!list[index] && index > 0) {
        this.$nextTick(() => {
          if (refs[index - 1]) {
            refs[index - 1].focus()
          }
        })
      }
    },
    // 验证中间四位是否正确
    handleNextStep() {
      const input = this.phoneDigits.join('')
      if (input === this.validDigits) {
        if(this.step == 2) {
          this.step = 3
          this.phone = this.userInfo.phone
          this.handleSendCode() // 进入验证码输入页后自动发送验证码
        }else if(this.step == 6) {
          this.step = 7
          this.phone = this.userInfo.phone
          this.handleSendCodeThree() // 进入验证码输入页后自动发送验证码
        }
      } else {
        this.$message.error('输入的中间四位手机号不正确')
      }
    },
    // 进入验证码输入页后自动发送验证码
    handleSendCode() {
      if (!this.canSend) return;
      // 发送验证码逻辑写这里（如调用接口）
      this.getChangePhoneCode()
      this.canSend = false;
      this.sendText = `重新发送(${this.countdown})`;

      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.timer);
          this.sendText = '发送';
          this.countdown = 60;
          this.canSend = true;
        } else {
          this.sendText = `重新发送(${this.countdown})`;
        }
      }, 1000);
    },
    // 新手机号发送验证码
    handleSendCodeTwo() {
      const phoneReg = /^1[3-9]\d{9}$/
      if (!this.newPhone) {
        this.$message({
          message: '请输入新手机号！',
          type: 'warning'
        })
        return
      }
      if (!phoneReg.test(this.newPhone)) {
        this.$message({
          message: '请输入正确的11位新手机号！',
          type: 'warning'
        })
        return
      }
      if (!this.canSendTwo) return;
      // 发送验证码逻辑写这里（如调用接口）
      this.getChangePhoneCode()
      this.canSendTwo = false;
      this.sendTextTwo = `重新发送(${this.countdownTwo})`;

      this.timerTwo = setInterval(() => {
        this.countdownTwo--;
        if (this.countdownTwo <= 0) {
          clearInterval(this.timerTwo);
          this.sendTextTwo = '获取验证码';
          this.countdownTwo = 60;
          this.canSendTwo = true;
        } else {
          this.sendTextTwo = `重新发送(${this.countdownTwo})`;
        }
      }, 1000);
    },
    // 进入验证码输入页后自动发送验证码
    handleSendCodeThree() {
      if (!this.canSendThree) return;
      // 发送验证码逻辑写这里（如调用接口）
      this.getDestroyPhoneCode()
      this.canSendThree = false;
      this.sendTextThree = `重新发送(${this.countdownThree})`;

      this.timerThree = setInterval(() => {
        this.canSendThree--;
        if (this.canSendThree <= 0) {
          clearInterval(this.timerThree);
          this.sendTextThree = '发送';
          this.canSendThree = 60;
          this.canSendThree = true;
        } else {
          this.sendTextThree = `重新发送(${this.canSendThree})`;
        }
      }, 1000);
    },
    // 账号销毁：发送手机验证码
    getDestroyPhoneCode() {
      getDestroyPhoneCode({
        phone: this.phone,
      }).then(res => {
        if (res.code != 'A00000') {
          this.$message.error(res.message);
        }
      })
    },
    // 账号销毁
    setPhoneDestroy() {
      const input = this.verifyCode.join('')
      setPhoneDestroy({
        phone: this.phone,
        code: input,
      }).then(res => {
        if (res.code == 'A00000') {
          localStorage.removeItem("x-token")
          localStorage.removeItem("userInfo")
          this.step = 8
        }else {
          this.$message.error(res.message);
        }
      })
    },
    // 登出系统
    onLogOut() {
      this.$router.push({ path: `/codeLogin` })
    },
    // 修改手机号：发送手机验证码
    getChangePhoneCode() {
      getChangePhoneCode({
        phone: this.step == 4 ? this.newPhone : this.phone,
      }).then(res => {
        if (res.code != 'A00000') {
          this.$message.error(res.message);
        }
      })
    },
    // 账号手机号验证
    verifyPhoneCode() {
      const input = this.verifyCode.join('')
      verifyPhoneCode({
        phone: this.phone,
        code: input,
      }).then(res => {
        if (res.code != 'A00000') {
          this.$message.error(res.message);
        } else {
          this.step = 4
        }
      })
    },
    // 修改新手机号
    changeNewPhone() {
      changeNewPhone({
        phone: this.newPhone,
        code: this.newVerifyCode,
      }).then(res => {
        if (res.code != 'A00000') {
          this.$message.error(res.message);
        } else {
          this.$message.success('修改成功');
          this.getCurrentUser()
          this.step = 1
        }
      })
    },
    // 获取当前登录用户
    async getCurrentUser() {
      await getCurrentUser().then(res => {
        if (res.code == 'A00000') {
          localStorage.setItem("userInfo", JSON.stringify(res.data[0]))
        }
      })
    },
    // 注销账号
    cancelUser() {
      this.step = 5
    },
    // 注销账户下一步
    handleCancelAnAccount() {
      if(this.checked) {
        this.step = 6
      }else {
        this.$message.warning('请阅读并同意《重要提醒》');
      }
    },
    // 设置密码
    handleChangePassword() {
      this.dialogVisible3 = true
    },
    handleClose() {
      this.dialogVisible3 = false
    },
    SubmitForm() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if(this.formData.passwordOld != this.formData.passwordNew) {
            this.$message({
              message: '两次密码不一致',
              type: 'warning'
            })
            return
          }
          changePasswordApi(this.formData).then(async (res) => {
            if(res.code == "A00000") {
              this.$message({
                message: '设置成功',
                type: 'success'
              })
              this.handleClose()
              await this.getCurrentUser()
              const info = localStorage.getItem("userInfo")
              this.userInfo = info ? JSON.parse(info) : {}
              this.formData.phone = this.userInfo.phone
              this.changePassword = this.userInfo.changePassword
            }else {
              this.$message({
                message: res.message,
                type: 'warning'
              })
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //   获取图片验证码
    getImgCode() {
      getCode().then(res => {
        this.codeImg = res.data[0].base64Image
        this.codeImgId = res.data[0].uuid
      })
    },
    // 获取手机验证码
    startCountdown() {
      const phoneReg = /^1[3-9]\d{9}$/
      if (!this.formData.phone) {
        this.$message({
          message: '请输入手机号！',
          type: 'warning'
        })
        return
      }
      if (!phoneReg.test(this.formData.phone)) {
        this.$message({
          message: '请输入正确的11位手机号！',
          type: 'warning'
        })
        return
      }
      // if(this.formData.codeImg == "") {
      //   this.$message({
      //     message: '请输入图片验证码',
      //     type: 'warning'
      //   })
      //   return
      // }
      if (!this.isCounting) {
        this.isCounting = true
        this.sendLoginCode()
      }
    },
    stopCountdown() {
      clearInterval(this.timer); // 清除定时器
      this.countdownText = "获取验证码"
      this.isCounting = false; // 重置状态为非倒计时中
      this.countdown2 = 60; // 重置倒计时秒数，可根据需要调整为其他值或者不重置
    },
    sendLoginCode() {
      sendLoginCode({
        phone: this.formData.phone,
      }).then(async res => {
        if (res.code == 'A00000') {
          this.countdown2 = 60
          this.countdownText = `${this.countdown2}秒后重新获取`
          this.timer = setInterval(() => {
            if (this.countdown2 > 0) {
              this.countdown2 -= 1
              this.countdownText = `${this.countdown2}秒后重新获取`
            } else {
              this.stopCountdown()
            }
          }, 1000)
        } else {
          this.$message({
            message: res.message,
            type: 'warning'
          })
          this.isCounting = false
        }
      })
    },
  }
}
</script>

<style scoped lang="less">
.bt {
  background: linear-gradient(151.62deg, #EF4034 17.54%, #D82E35 117.32%);
  color: #fff;
  font-size: 16px;
  height: 44px;
  border-radius: 6px;
  width: 255px;
  border: none;
  margin-top: 280px;
  display: block;
}

.bt-box {
  margin-top: 280px;
  display: flex;
  align-items: center;

  .bt {
    margin-top: 0;
    margin: 0 10px;
    width: calc(50% - 30px);
  }
}

.close-an-account-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: left;
  padding: 0 120px;
  box-sizing: border-box;

  .close-an-account-img {
    width: 80px;
    height: 92px;
    vertical-align: bottom;
    margin-bottom: 18px;
  }

  .close-an-account-img-two {
    width: 40px;
    height: 28px;
    vertical-align: bottom;
    margin-bottom: 24px;
  }

  .close-an-account-title {
    font-size: 22px;
    font-weight: 500;
    color: #262626;
    margin-bottom: 12px;
  }

  .close-an-account-subheading{
    color: #262626;
    font-size: 15px;
    margin-bottom: 26px;
  }

  .close-an-account-list {
    background-color: #F5F5F5;
    border-radius: 6px;
    width: 100%;
    padding: 12px;
    box-sizing: border-box;
    margin-bottom: 100px;

    .close-an-account-item {
      color: #262626;
      font-size: 14px;
      margin-bottom: 12px;
      position: relative;
      padding-left: 10px;
    }

    .close-an-account-item::after {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 3px;
      background-color: #262626;
      border-radius: 50%;
    }
  }

  .close-an-account-known {
    color: #262626;
    font-size: 14px;
    margin-bottom: 30px;

    /deep/.el-checkbox__inner:hover {
      border-color: #BD181E;
    }

    /deep/.el-checkbox__input.is-checked .el-checkbox__inner {
      border-color: #BD181E;
      background-color: #BD181E;
    }

    /deep/.el-checkbox__input.is-focus .el-checkbox__inner {
      border-color: #BD181E;
    }

    .close-an-account-span {
      color: #BD181E;
      cursor: pointer;
    }
  }

  .close-an-account-btn {
    display: flex;

    .btn-item {
      background: linear-gradient(151.62deg, #EF4034 17.54%, #D82E35 117.32%);
      color: #fff;
      font-size: 16px;
      height: 44px;
      border-radius: 6px;
      width: 255px;
      border: none;
      display: block;
    }
  }
}

.update-box {
  width: 510px;
  margin: auto;
  margin-top: 95px;

  .update-title {
    margin-bottom: 20px;
    color: #262626;
    font-size: 16px;
    line-height: 24px;
    font-weight: bold;
  }

  .update-input {
    border-bottom: 1px solid #E5E5E5;
    height: 84px;

    /deep/.el-input__inner {
      border: none;
      font-size: 16px;
    }

    .ub {
      color: #BD181E;
      font-size: 16px;
      border-right: 1px solid #BD181E;
      width: 80px;
      margin-right: 5px;
    }

    display: flex;
    align-items: center;
  }
}

.iphone-box {
  width: 600px;
  margin: auto;
  margin-top: 95px;

  .iphone-number {
    color: #262626;
    font-size: 26px;
    font-weight: bold;
    line-height: 26px;
    margin-top: 58px;
  }

  .iphone-yz,
  .iphone-yzm {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;

    input {
      width: 58px;
      height: 58px;
      font-size: 30px;
      font-weight: bold;
      text-align: center;
      line-height: 58px;
      color: #000;
      margin: 0 10px;
      border: 1px solid #A3A3A3;
      border-radius: 4px;
    }
  }

  .iphone-p {
    color: #A3A3A3;
    font-size: 14px;
    line-height: 20px;
    margin-top: 12px;

    span {
      cursor: pointer;
      color: #BD181E;
      margin-left: 10px;
    }
  }

  .iphone-label {
    border-radius: 4px;
    background: rgba(189, 24, 30, 0.04);
    color: #BD181E;
    font-size: 14px;
    height: 44px;
    padding: 0 10px;
    line-height: 44px;
  }
}

.account-box {
  width: 702px;
  margin: 33px auto;

  .account-li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E5E5E5;
    cursor: pointer;
    height: 80px;

    .account-left {
      color: #262626;
      font-size: 16px;
      line-height: 16px;
      text-align: left;

      div {
        font-size: 12px;
      }
    }

    .active {
      color: #BD181E;
    }

    .account-right {
      font-size: 14px;
      display: flex;
      align-items: center;
    }
  }
}

.AccountSecurity-box {
  .title-box {
    border-bottom: 1px solid #E4E7EB;
    height: 66px;
    color: #BD181E;
    font-size: 18px;
    line-height: 70px;
    position: relative;
    font-weight: bold;
    padding: 0 24px;
  }

  .title-box:before {
    content: '';
    background: #BD181E;
    width: 90px;
    height: 2px;
    position: absolute;
    bottom: 0;
    display: block;
  }
}

.settings-box {
  padding: 50px 36px;
  text-align: left;

  .user-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    .user-left {
      display: flex;
      align-items: center;
    }

    .head {
      width: 52px;
      height: 52px;
      border-radius: 50%;
    }

    .name {
      color: #262626;
      font-size: 15px;
      line-height: 22px;
      margin-left: 8px;
      font-weight: bold;
    }
  }

  .settings-ul {
    margin-top: 26px;

    .settings-li {
      height: 54px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      border-bottom: 1px solid #E5E5E5;

      span {
        font-size: 15px;
        color: #262626;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/PersonalCenter/components/Settings.vue